module.exports = __webpack_public_path__ + "img/组 3.bc948331.png";